import {
  menuCross
} from './menu-cross';

export const linksSeo = () => {
  const menuHamburguesa = jQuery('#js-navigation');
  jQuery(window).on('orientationchange', () => {
    switch (window.screen.orientation.angle) {
      case 90:
        if (jQuery(window).width() > 800) {
          jQuery('#js-navigation').remove();
          if (jQuery('#menu-cross').length === 0) {
            let menuData;

            if (window.location.origin.indexOf('localhost') >= 0 || window.location.origin.indexOf('slots-ux') >= 0) {
              /* eslint-disable global-require */
              menuData = require('./menu-information.json');
              menuCross(menuData);
            } else {
              fetch('/static/json/menu-information.json')
                .then(response => response.json())
                .then(json => {
                  menuData = json;
                  menuCross(menuData);
                }).catch(() => {
                // Error :(
                });
            }
            jQuery('.navigation--opened').removeClass('navigation--opened');
          }
        }
        break;

      default:
        jQuery('#menu-cross').remove();
        menuHamburguesa.insertAfter('body');
        break;
    }
  });

  function validMenu() {
    if (jQuery(window).width() > 800) {
      jQuery('#js-navigation').remove();
    } else {
      jQuery('#menu-cross').remove();
    }
  }
  setTimeout(validMenu, 100);
};



// WEBPACK FOOTER //
// ./src/_override/shared/menu-cross/hideLinksMainMenu.js